module.exports = __webpack_public_path__ + "static/media/guandao_pic3.e92c60a4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic3.jpg
 ** module id = 439
 ** module chunks = 0
 **/